"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactcss = _interopRequireDefault(require("reactcss"));
var _reactColor = require("react-color");
require("react-frontend-utils/dist/styles.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Color Picker component shows a square button with a color, clicking on the button brings up the SketchPicker from react-color.  Clicking elsewhere closes
 * the picker.  Selecting a new color changes the button background color.
 * 
 * The caller can pass the following optional props:
 * 
 * initialColor: initial color, either an object with rgba property or a hex string (no alpha)
 * color: if this is set, the color will be dynamically set when opened - otherwise the last color set will be used
 * disableAlpha: don't allow alpha select (default = false)
 * width: width of the button, default 24px
 * height: height of the button, default 24px
 * disabled: if true, color picker popup will not open
 * button: the button component to render, default is a square button of the width and height above
 * alignRight: if true, the popup is positioned right-aligned with the button's right edge. If you supply a button, you should supply it's width so the 
 *             correct position can be calculated
 * 
 * onChange: a callback function that receives a color object any time the picker is changed. Use the .rgb key or .hex property to get the color
 * onClose: a callback function that is called when the popup closes
 * 
 */
var ColorPicker = exports.ColorPicker = /*#__PURE__*/function (_Component) {
  function ColorPicker(props) {
    var _this;
    _classCallCheck(this, ColorPicker);
    _this = _callSuper(this, ColorPicker, [props]);
    _defineProperty(_this, "state", {
      displayColorPicker: false,
      color: {
        r: '241',
        g: '112',
        b: '19',
        a: '1'
      }
    });
    _defineProperty(_this, "handleClick", function () {
      var shouldDisplay = !_this.state.displayColorPicker;
      _this.setState({
        displayColorPicker: shouldDisplay
      });
      if (!shouldDisplay) _this.handleClose();
    });
    _defineProperty(_this, "handleClose", function () {
      _this.setState({
        displayColorPicker: false
      });
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    });
    _defineProperty(_this, "handleChange", function (color) {
      _this.setState({
        color: color.rgb
      });
      if (_this.props.onChange) {
        _this.props.onChange(color);
      }
    });
    if (props.initialColor) _this.state.color = props.initialColor;
    return _this;
  }
  _inherits(ColorPicker, _Component);
  return _createClass(ColorPicker, [{
    key: "render",
    value: function render() {
      var buttonWidth = this.props.width ? this.props.width : '24px';
      var shiftRight = 210 - parseInt(buttonWidth); // width of the popover is 220
      var transformString = "translateX(-".concat(shiftRight, "px)");
      var styles = (0, _reactcss["default"])({
        'default': {
          color: {
            width: this.props.width ? this.props.width : '24px',
            height: this.props.height ? this.props.height : '24px',
            borderRadius: '2px',
            background: this.state.color.r ? "rgba(".concat(this.state.color.r, ", ").concat(this.state.color.g, ", ").concat(this.state.color.b, ", ").concat(this.state.color.a, ")") : this.state.color
          },
          swatch: {
            padding: '5px',
            background: '#fff',
            borderRadius: '1px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
            display: 'inline-block',
            cursor: 'pointer'
          },
          popover: {
            position: 'absolute',
            zIndex: '2',
            transform: this.props.alignRight ? transformString : 'translateX(0px)'
          },
          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px'
          }
        }
      });
      var defaultButton = /*#__PURE__*/_react["default"].createElement("div", {
        className: "color-picker-button",
        style: styles.swatch
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.color
      }));
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: this.handleClick
      }, this.props.button ? this.props.button : defaultButton), this.state.displayColorPicker && !this.props.disabled ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.cover,
        onClick: this.handleClose
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.popover
      }, /*#__PURE__*/_react["default"].createElement(_reactColor.SketchPicker, {
        disableAlpha: this.props.disableAlpha,
        color: this.props.color ? this.props.color : this.state.color,
        onChange: this.handleChange
      }))) : null);
    }
  }]);
}(_react.Component);